export const getDeletePaymentMethodModalId = (paymentMethodId: string) =>
  `${paymentMethodId}-delete-payment-method-modal`
